
let merchant = [
    {
        path: 'merchant',
        name: '商户中心',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
              {
                path: 'customer',
                component: () => import("@/views/admin/memberCenter/merchant/customer/index.vue"),
                name: '商户管理',
                meta: {
                  hidden: true,
                  key:100001
                },
              },
        ]
    }
]



let member = [
    {
        path: 'member',
        name: '会员中心',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'management',
                component: () => import("@/views/admin/memberCenter/member/management/index.vue"),
                name: '会员管理',
                meta: {
                    hidden: true,
                    key:200001
                },
            },
            {
                path: 'storagerecord',
                component: () => import("@/views/admin/memberCenter/member/storagerecord/index.vue"),
                name: '储值记录',
                meta: {
                    hidden: true,
                    key:200002
                },
            },
        ]
    }
]

export const memberCenter = [
    {
        path: '/member-center',
        name: '会员系统',
        redirect: '/member-center/wares',
        component: () => import("@/views/layout/index.vue"),
        children: [
            ...merchant,//商户中心
            ...member,//会员管理
        ]
    },

]
